
import { mchInfos } from '@/apis/home.js'
import { gyms_list } from '@/apis/insidepage.js';
export default {
    data() {
        return {
            items: [],
            mchInfos: [],
            venues: [],
        }
    },
    mounted() {
        //this.onPageLoad();
        this.getMchInfos();
        this.getVenues();
    },
    methods: {
        async getMchInfos() {
            try {
                const res = await mchInfos() || {};
                if (res.code == 0) {
                    const data = res.data || {};
                    this.mchInfos = data.records || [];
                    if (this.mchInfos.length > 0)
                        this.mchInfos = this.mchInfos.slice(0, 6);
                } else {
                    if (res.msg)
                        throw new Error(res.msg);
                }
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        async getVenues() {
            try {
                const params = {
                    name: '',
                    serviceType: 'TENANT',
                    areaCode: '',
                    module: '',
                    latitude: 0,
                    longitude: 0,
                    sortBy: '綜合排序',
                    priceRangeMin: 0,
                    priceRangeMax: 0,
                    filtersTime: '',
                    selectedTime: '',
                    score: '',
                    pageNumber: 1,
                    pageSize: 6
                };
                const res = await gyms_list(params);
                if (res && res.code == 0) {
                    const data = res.data || {};
                    this.venues = data.records;
                } else {
                    if (res) this.$message.error('加載失敗：' + res.msg);
                }
            } catch (error) {

            }
        },

        // async onPageLoad() {
        //     this.items = this.$store.state.systemConfig;
        // },

        // getItemValue(key) {
        //     const items = this.$store.state.systemConfig || [];
        //     const res = items.filter(item => item.configKey == key);
        //     if (res.length > 0) {
        //         return res[0].configVal;
        //     }
        //     return '';
        // },
    }
}
